
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legaltech-resources-for-lawyers",
      function () {
        return require("private-next-pages/legaltech-resources-for-lawyers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legaltech-resources-for-lawyers"])
      });
    }
  